export function getMenuItemText(element) {
  if (typeof element === 'string') {
    return element;
  }
  if (Array.isArray(element)) {
    return element.map(getMenuItemText).join('');
  }
  if (element.props && element.props.children) {
    // Extract text from child components
    const childText = getMenuItemText(element.props.children);
    return childText;
  }
  return '';
}